import React from "react";
import { LOGO } from "@/lib/helpers";
import { Button } from "@/components/ui/button";
import { ShieldCheck, TrendingUp, Users } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const denied = new URLSearchParams(window.location.search).get("denied") === "1";
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between bg-gold p-12 text-navy-900 overflow-hidden">
        <div
          className="absolute inset-0 opacity-0"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1656055450481-e47bc720e687?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="relative z-10 flex items-center gap-4">
          <img src={LOGO} alt="VNS" className="h-16 w-16 object-contain bg-white rounded-lg p-1" />
          <div>
            <div className="font-heading text-2xl font-bold text-navy-900 tracking-tight">VNS Vinayaka</div>
            <div className="text-xs uppercase tracking-[0.3em] text-navy/60">Group of Enterprises</div>
          </div>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="font-heading text-4xl font-extrabold leading-tight tracking-tight">
            Operations Management
            <br />
            <span className="text-navy-900 underline decoration-white/70 decoration-2 underline-offset-4">for the Data Entry Division</span>
          </h1>
          <p className="text-navy/80 max-w-md">
            Executive dashboards, work logs, attendance, quality checks and performance ranking — all
            automated in one premium enterprise platform.
          </p>
          <div className="flex gap-8 pt-4">
            {[
              { icon: TrendingUp, t: "Live KPIs" },
              { icon: Users, t: "Team Insights" },
              { icon: ShieldCheck, t: "Role Secured" },
            ].map((f) => (
              <div key={f.t} className="flex items-center gap-2 text-sm text-navy-900">
                <f.icon className="h-5 w-5 text-navy-900" />
                {f.t}
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-10 text-xs text-navy/70">
          © {new Date().getFullYear()} VNS Vinayaka Group of Enterprises
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex flex-col items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm text-center">
          <img src={LOGO} alt="VNS" className="h-20 w-20 object-contain mx-auto lg:hidden mb-6" />
          <h2 className="font-heading text-3xl font-extrabold text-navy tracking-tight">Welcome back</h2>
          <p className="mt-2 text-slate-500">Sign in to access your operations workspace</p>

          {denied && (
            <div data-testid="login-denied-banner" className="mt-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              This Google account is not authorised to access VNS Vinayaka Desk. Only the Founder, Head and registered data-entry operators can sign in. Please contact your administrator.
            </div>
          )}

          <Button
            onClick={handleLogin}
            data-testid="google-login-btn"
            className="mt-8 w-full h-12 bg-navy hover:bg-navy-900 text-white font-medium rounded-lg text-base"
          >
            <svg className="mr-3 h-5 w-5" viewBox="0 0 24 24">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35 24 35c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 5.1 29.5 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z" />
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 5.1 29.5 3 24 3 16 3 9.1 7.6 6.3 14.7z" />
              <path fill="#4CAF50" d="M24 45c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 36 26.7 37 24 37c-5.3 0-9.7-2.6-11.3-7l-6.5 5C9 40.3 16 45 24 45z" />
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.6 36.4 45 30.8 45 24c0-1.2-.1-2.3-.4-3.5z" />
            </svg>
            Continue with Google
          </Button>

          <p className="mt-6 text-xs text-slate-400">
            Access is role-based. Founders and Heads get full visibility; employees see only their own workspace.
          </p>
        </div>
      </div>
    </div>
  );
}
